import { camelCase } from '@edicom/common/case/camelCase';
import { TYPES } from './TYPES.constant';
import { CELLS } from './CELLS.constant';

const GENERATE_SUFFIX = 'FormBuilder';
const CELL_SUFFIX = 'FormBuilderCell';

injectorService.$inject = ['$injector', 'FbCellRenderer', 'FbCellEditor'];

/**
 * Este servicio se encarga de buscar y devolver el servicio para generar el HTML del tipo buscado.
 * Primero busca si existe un servicio angularjs que se llama "<tipo>FormBuilder",
 * Segundo busca entre los tipos predefinidos en el formBuilder.
 *
 * Tiene dos metodos, `generate` para los tipos de cabecera, y `cell` para cuando estamos dentro de un grid.
 */

export default function injectorService($injector, FbCellRenderer, FbCellEditor) {
  return { generate, cell };

  function generate(type) {
    const name = camelCase(type);

    // primero buscamos un servicio xxxFormBuilder
    const service = injector(name + GENERATE_SUFFIX);
    if (service) {
      return service;
    }

    // segundo buscamos un servicio estandár (los por defecto del formBuilder)
    if (TYPES[name]) {
      return TYPES[name]({ TYPES });
    }

    console.warn(`ecFormBuilder injector.generate: servicio no encontrado para tipo "${type}"`);
    return false;
  }

  function cell(type) {
    const name = camelCase(type);
    const service = injector(name + CELL_SUFFIX);
    if (service) {
      return service;
    }

    if (CELLS[name]) {
      return CELLS[name]({ TYPES, FbCellRenderer, FbCellEditor, CELLS });
    }

    console.warn(`ecFormBuilder injector.cell: servicio no encontrado para tipo "${type}"`);
    return false;
  }

  function injector(name = '') {
    if ($injector.has(name)) {
      return $injector.get(name);
    }
  }
}
